import { isArray, isEmpty } from 'lodash';
import { STATE_KEYS } from './state';
import { widgetService } from '../../../../services/widget/WidgetService';

const GETTER_TYPES = {
  GET_CURRENT_WIDGET_ID: 'getCurrentWidgetId',
  GET_DATA_STATE: 'getDataState',
  GET_WIDGETS: 'getWidgets',
  GET_CONFIGURATION_STEP_IDX: 'getConfigurationStepIndex',
  GET_ALL_CONFIGURATION_STEPS: 'getAllConfigurationSteps',
  GET_NAVIGATOR_CONFIGURATION_STEPS: 'getNavigatorConfigurationSteps',
  GET_WIDGET_CONNECTION: 'getWidgetConnection',
  GET_WIDGET_CONNECTION_BY_ID: 'getWidgetConnectionById',
  GET_WIDGET_VIEW: 'getWidgetView',
  GET_WIDGET_LAYOUT: 'getWidgetLayout',
  GET_WIDGETS_CONFIGURATION: 'getWidgetsConfiguration',
  GET_WIDGETS_CONFIGURATION_CURRENT: 'getWidgetsConfigurationCurrent',
  GET_CONNECTION_TEST_RESULT: 'getWidgetConnectionTestResult',
  GET_DELETE_RESPONSE: 'getWidgetDeleteConnectionResponse',
  GET_EXPLORER_RESPONSE: 'getWidgetExplorerResponse',
  GET_WIDGET_CUSTOMIZATION: 'getWidgetCustomization',
};

const getters = {
  [GETTER_TYPES.GET_CURRENT_WIDGET_ID](state) {
    return state[STATE_KEYS.CURRENT_WIDGET_ID];
  },
  [GETTER_TYPES.GET_DATA_STATE](state) {
    return state[STATE_KEYS.DATA_STATE];
  },
  [GETTER_TYPES.GET_WIDGETS](state) {
    return state[STATE_KEYS.WIDGETS];
  },
  [GETTER_TYPES.GET_CONFIGURATION_STEP_IDX](state) {
    return state[STATE_KEYS.CONFIGURATION_STEP_IDX];
  },
  [GETTER_TYPES.GET_ALL_CONFIGURATION_STEPS](state) {
    return state[STATE_KEYS.ALL_CONFIGURATION_STEPS];
  },
  [GETTER_TYPES.GET_NAVIGATOR_CONFIGURATION_STEPS](state) {
    const allSteps = state[STATE_KEYS.ALL_CONFIGURATION_STEPS];
    return allSteps.filter(({ navigator }) => !!navigator);
  },
  [GETTER_TYPES.GET_WIDGET_CONNECTION](state) {
    return state[STATE_KEYS.WIDGET_CONNECTION];
  },
  [GETTER_TYPES.GET_WIDGET_CONNECTION_BY_ID]() {
    return async widgetId =>
      // eslint-disable-next-line no-return-await
      await widgetService.getConnectionById(widgetId);
  },
  [GETTER_TYPES.GET_WIDGET_VIEW](state) {
    return state[STATE_KEYS.WIDGET_VIEW];
  },
  [GETTER_TYPES.GET_WIDGET_CUSTOMIZATION](state) {
    return state[STATE_KEYS.WIDGET_CUSTOMIZATION];
  },
  [GETTER_TYPES.GET_WIDGET_LAYOUT](state) {
    return state[STATE_KEYS.WIDGET_LAYOUT];
  },
  [GETTER_TYPES.GET_WIDGETS_CONFIGURATION](state) {
    return state[STATE_KEYS.WIDGETS_CONFIGURATION];
  },
  [GETTER_TYPES.GET_WIDGETS_CONFIGURATION_CURRENT](state) {
    if (!isArray(state[STATE_KEYS.WIDGETS_CONFIGURATION]) || isEmpty(state[STATE_KEYS.WIDGETS_CONFIGURATION])) {
      console.warn('Widget configurations not present.');
    } else {
      const currentWidgetId = state[STATE_KEYS.CURRENT_WIDGET_ID];
      if (currentWidgetId) {
        const config = state[STATE_KEYS.WIDGETS_CONFIGURATION].find(
          widgetConfig => widgetConfig.id && widgetConfig.id === currentWidgetId);
        if (config) {
          return config;
        }
      }
      console.error(`Widget configuration could not be established for: '${currentWidgetId}'.`);
      return null;
    }
    return null;
  },
  [GETTER_TYPES.GET_CONNECTION_TEST_RESULT](state) {
    return state[STATE_KEYS.CONNECTION_TEST_RESULT];
  },
  [GETTER_TYPES.GET_DELETE_RESPONSE](state) {
    return state[STATE_KEYS.DELETE_RESPONSE];
  },
  [GETTER_TYPES.GET_EXPLORER_RESPONSE](state) {
    return state[STATE_KEYS.EXPLORER_RESPONSE];
  },
};

export {
  getters,
  GETTER_TYPES,
};
